import { useEffect, useMemo, useState } from 'react';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
import { OfferIcon } from '../../../util/icons';
import { BLOCK_HISTORY_OFFERS } from '../../../redux/actions/eth';
import OffersRow from '../../../components/Offers';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { BUYING, SELLING } from '../../../components/Offers/Offer/config';
import Page from '../../../components/Page';
import PageTitle from '../../../components/PageTitle';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const Offers = () => {

    const dispatch = useDispatch(),
    labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    [ activeTab, setActiveTab ] = useState( 0 ),
    { accounts, offers, newOffers } = useSelector( state => state.eth ),
    buyOffers = Boolean( newOffers.buy > 0 ),
    sellOffers = Boolean( newOffers.sell > 0 );

    // clear history after the user views the page
    useEffect(() => {
        return () => {
            dispatch({ type: BLOCK_HISTORY_OFFERS });
        }
    }, [ dispatch ]);

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale );
    }, [ labels, locale ]);
   
    return (
        <Page modifier="offers" title={ labels.title }>
            
            <PageTitle 
                Icon={ OfferIcon } 
                title={ labels.title }
                subtitle={
                    labels.formatString(
                        labels.subtitle,
                        <strong>{ accounts[ 0 ] }</strong>
                    )
                }/>

            <Box className="coe__offers__tabs" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={ activeTab } onChange={ ( e, value ) => setActiveTab( value ) } >
                    <Tab icon={ buyOffers ? <Chip color="error" label={ newOffers.buy } size="small" /> : null } iconPosition="end" label={ labels.offersBuy } />
                    <Tab icon={ sellOffers ? <Chip color="error" label={ newOffers.sell } size="small" /> : null } iconPosition="end" label={ labels.offersSell } />                
                </Tabs>
            </Box>

            {
                activeTab === 1 ?
                    <TableContainer component={ Paper } elevation={ 6 }>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{ labels.from }</TableCell>
                                    <TableCell align="right">{ labels.tokenId }</TableCell>
                                    <TableCell>{ labels.boardName }</TableCell>
                                    <TableCell align="right">{ labels.amount }</TableCell>
                                    <TableCell>{ labels.status }</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <OffersRow 
                                    direction={ SELLING }
                                    offers={ offers.sell } 
                                    noData={ labels.noSellOffers } />
                            </TableBody>
                        </Table>
                    </TableContainer>:
                    null
            }

            {
                activeTab === 0 ?
                    <TableContainer component={ Paper } elevation={ 6 }>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{ labels.to }</TableCell>
                                    <TableCell align="right">{ labels.tokenId }</TableCell>
                                    <TableCell>{ labels.boardName }</TableCell>
                                    <TableCell align="right">{ labels.amount }</TableCell>
                                    <TableCell>{ labels.status }</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <OffersRow 
                                    direction={ BUYING }
                                    offers={ offers.buy } 
                                    noData={ labels.noBuyOffers } />
                            </TableBody>
                        </Table>
                    </TableContainer> :
                    null
            }
        </Page>
    )

}

export default Offers;